import React from 'react';
import { Box } from '@mui/material';
import { colors, fonts, borderRadius } from '../../../constants';
import EditQueryFieldLabel from './EditQueryFieldLabel';

/**
 * EditQueryInputField Component
 * Reusable input field for EditQueryModal
 * 
 * @param {string} label - Field label
 * @param {boolean} required - Whether field is required
 * @param {string} value - Input value
 * @param {Function} onChange - Change handler
 * @param {Function} onFocus - Focus handler
 * @param {Function} onBlur - Blur handler
 * @param {boolean} disabled - Whether field is disabled
 * @param {boolean} hasError - Whether field has error
 * @param {boolean} isFocused - Whether field is focused
 * @param {string} placeholder - Placeholder text
 * @param {string} type - Input type
 */
const EditQueryInputField = ({
  label,
  required = false,
  value,
  onChange,
  onFocus,
  onBlur,
  disabled = false,
  hasError = false,
  isFocused = false,
  placeholder = '',
  type = 'text',
}) => {
  const getInputStyle = () => {
    if (disabled) {
      return {
        width: '100%',
        padding: '10px 12px',
        fontSize: fonts.fontSizeSm,
        fontFamily: fonts.fontFamily,
        background: colors.backgroundSoft,
        borderRadius: borderRadius.input,
        border: `1px solid ${colors.borderHover}`,
        minHeight: '36px',
        lineHeight: 1.4,
        boxSizing: 'border-box',
        opacity: 1,
        cursor: 'not-allowed',
        color: colors.textPrimaryDark,
      };
    }

    return {
      width: '100%',
      padding: '10px 12px',
      fontSize: fonts.fontSizeSm,
      fontFamily: fonts.fontFamily,
      background: 'linear-gradient(135deg, #ffffff 0%, #f7faff 100%)',
      borderRadius: borderRadius.input,
      border: isFocused
        ? `2px solid ${hasError ? colors.error : '#0e172a'}`
        : `1.5px solid ${hasError ? colors.error : colors.borderDefault}`,
      minHeight: '36px',
      lineHeight: 1.4,
      transition: 'all 0.2s ease-in-out',
      outline: 'none',
      boxSizing: 'border-box',
      boxShadow: isFocused
        ? '0 0 0 4px rgba(66, 133, 244, 0.12)'
        : 'inset 0 1px 3px rgba(15, 63, 128, 0.08)',
      cursor: 'text',
      color: colors.textPrimaryDark,
    };
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      {label && <EditQueryFieldLabel label={label} required={required} />}
      <input
        type={type}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
        placeholder={placeholder}
        style={getInputStyle()}
      />
    </Box>
  );
};

export default EditQueryInputField;
